/** Formats a byte count as a human-readable string, e.g. 3355443 -> "3.2 MB". */
export function formatBytes(bytes: number, decimals = 1): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = sizes[Math.min(i, sizes.length - 1)];
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${size}`;
}
